import type { FaireProductEntity } from "../../entity_types/product";

export const p_gvdp5nhav8: FaireProductEntity = {
  token: "p_gvdp5nhav8",
  type: "product",
  name: "\u2728 Clear Acrylic Tray \u2013 Fits 3x3, 3x4 & 4x6 Post-it\u00ae Notes",
  brandName: "Post-it\u00ae Notes Design Series",
  imageUrl:
    "https://cdn.faire.com/fastly/3a9dc3cf25659eb9b0d9c2285fd3d9f65ae7f448c0f077b08c1ad341f94c48c6.jpeg",
  priceDollars: 0.85,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a82b3f398cf4e09d078b6bba43b75612177530f0309d5e2cf97def4ce30b85e1.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
